(function () {

        var TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

        angular
            .module('app')
            .controller('SignupController', SignupController);

        SignupController.$inject = [
            'authService',
            'usersService',
            'scrollService',
            'loggerService',
            '$scope',
            'utilService'
        ];

        function SignupController(authService, usersService, scrollService, loggerService, $scope, utilService) {
            var vm = this;
            vm.authService = authService;
            vm.oidcLoginEnabled = typeof OIDC_LOGIN_ENABLED !== 'undefined' && OIDC_LOGIN_ENABLED;

            vm.focused = '';

            var alertId = 1;
            vm.errors = [];
            vm.infos = [];
            vm.dismissAlert = function (type, errIdx) {
                vm[type].splice(errIdx, 1);
            };
            function displayAlert(type, status, errObj) {
                if (!errObj) {
                    errObj = {};
                }
                var newId = alertId++;
                vm[type].push({
                    alertid : newId,
                    message : errObj.message || errObj.error || 'Unknown error',
                    status : status
                });
                scrollService.scrollToNewItem(type + newId);
            }

            vm.creating = false;
            vm.complete = false;
            vm.validationMessage = '';
            vm.checkPasswordMatch = function (newClass, password, passwordconfirm) {
                if (newClass && newClass.passwordconfirm) {
                    newClass.passwordconfirm.$setValidity('nomatch', !passwordconfirm || password === passwordconfirm);
                }
            };

            vm.confirm = function (newClassDetails, newClass, acceptedTerms) {
                vm.validationMessage = '';

                if (vm.oidcLoginEnabled) {
                    displayAlert('errors', 400, {
                        message : '正式平台账号请由课程负责人或平台管理员在统一身份系统中开通。'
                    });
                    return;
                }

                if (!isSignupFormReady(newClass, acceptedTerms)) {
                    markSignupFormTouched(newClass);
                    vm.validationMessage = getSignupValidationMessage(newClass, acceptedTerms);
                    return;
                }

                vm.creating = true;

                if (isLocalPreviewHost()) {
                    return createTeacher(newClassDetails, 'local-dev-turnstile');
                }

                return utilService.loadScript(TURNSTILE_SCRIPT_URL).then(function () {
                if (!document.getElementById('turnstile-container') || typeof turnstile === 'undefined') {
                    displayAlert('errors', 500, {
                        message : '无法加载人机验证，请刷新页面后再试。'
                    });
                    vm.creating = false;
                    return;
                }

                loggerService.debug('[ml4ksignup] Creating new class', newClassDetails);
                document.getElementById('turnstile-container').innerHTML = '';
                turnstile.render("#turnstile-container", {
                    sitekey: TURNSTILE_SITE_KEY,
                    'error-callback': function (err) {
                        loggerService.error('[ml4ksignup] Failed to get turnstile token', err);

                        $scope.turnstileerror = err;
                        vm.creating = false;
                    },
                    callback: function (token) {
                        if (!vm.complete) {
                            createTeacher(newClassDetails, token);
                        }
                    }
                });
                }).catch(function (err) {
                    loggerService.error('[ml4ksignup] Failed to load turnstile', err);
                    displayAlert('errors', 500, {
                        message : '人机验证暂时无法加载，请刷新页面后再试。'
                    });
                    vm.creating = false;
                });
            };

            function isLocalPreviewHost() {
                return (window.location.hostname === '127.0.0.1' ||
                        window.location.hostname === 'localhost') &&
                       (window.location.port === '8000' || window.location.port === '');
            }

            function createTeacher(newClassDetails, token) {
                loggerService.debug('[ml4ksignup] Creating new class', newClassDetails);
                return usersService.createTeacher(
                    newClassDetails.username,
                    newClassDetails.email,
                    newClassDetails.password,
                    newClassDetails.intendeduse,
                    token
                )
                    .then(function (resp) {
                        loggerService.debug('[ml4ksignup] Created class', resp);

                        var newId = alertId++;
                        vm.infos.push({
                            alertid : newId,
                            password : resp.password
                        });
                        scrollService.scrollToNewItem('infos' + newId);

                        vm.creating = false;
                        vm.complete = true;
                    })
                    .catch(function (err) {
                        vm.creating = false;

                        loggerService.error('[ml4ksignup] Failed to create class', err);

                        if (err && err.data && err.data.error && err.data.error.includes('turnstile')) {
                            $scope.turnstileerror = err.data.error;
                        }
                        else {
                            displayAlert('errors', err.status || 500, err.data);
                        }
                    });
            }

            function isSignupFormReady(newClass, acceptedTerms) {
                return newClass && !newClass.$invalid && acceptedTerms === true;
            }

            function markSignupFormTouched(newClass) {
                if (!newClass) {
                    return;
                }
                if (newClass.username) {
                    newClass.username.$setTouched();
                }
                if (newClass.email) {
                    newClass.email.$setTouched();
                }
                if (newClass.password) {
                    newClass.password.$setTouched();
                }
                if (newClass.passwordconfirm) {
                    newClass.passwordconfirm.$setTouched();
                }
                if (newClass.intendeduse) {
                    newClass.intendeduse.$setTouched();
                }
            }

            function getSignupValidationMessage(newClass, acceptedTerms) {
                if (!newClass) {
                    return '请先填写账号信息。';
                }
                if (newClass.username && newClass.username.$error.required) {
                    vm.focused = 'username';
                    return '请先填写用户名。';
                }
                if (newClass.username && newClass.username.$error.pattern) {
                    vm.focused = 'username';
                    return '用户名只能包含字母、数字、横线或下划线。';
                }
                if (newClass.username &&
                    (newClass.username.$error.maxlength || newClass.username.$error['md-maxlength'])) {
                    vm.focused = 'username';
                    return '用户名太长了，请控制在 32 个字符以内。';
                }
                if (newClass.email && newClass.email.$error.required) {
                    vm.focused = 'email';
                    return '请先填写邮箱地址。';
                }
                if (newClass.email && newClass.email.$error.email) {
                    vm.focused = 'email';
                    return '邮箱格式看起来不正确，请检查后再创建。';
                }
                if (newClass.password && newClass.password.$error.required) {
                    vm.focused = 'password';
                    return '请设置登录密码。';
                }
                if (newClass.password && newClass.password.$error.minlength) {
                    vm.focused = 'password';
                    return '密码至少需要 8 个字符。';
                }
                if (newClass.passwordconfirm && newClass.passwordconfirm.$error.required) {
                    vm.focused = 'passwordconfirm';
                    return '请再次输入密码。';
                }
                if (newClass.passwordconfirm && newClass.passwordconfirm.$error.nomatch) {
                    vm.focused = 'passwordconfirm';
                    return '两次输入的密码不一致。';
                }
                if (acceptedTerms !== true) {
                    vm.focused = 'terms';
                    return '请先勾选教师账号责任确认。';
                }
                return '请检查表单里标红的内容，然后再创建班级账号。';
            }
        }

    }());
